import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import {
  createTheme,
  PaletteColor,
  PaletteColorOptions,
  ThemeProvider,
  useTheme,
} from "@mui/material/styles";
import React from "react";
import {
  createMakeStyles,
  createWithStyles,
  TssCacheProvider,
} from "tss-react";

// declare module "@mui/material/styles/createPalette" {
declare module "@mui/material/styles" {
  interface Palette {
    validation: {
      success: PaletteColor;
      warn: PaletteColor;
    };
  }

  interface PaletteOptions {
    validation: {
      success: PaletteColorOptions;
      warn: PaletteColorOptions;
    };
  }
}

const theme = createTheme({
  shape: {
    borderRadius: 12,
  },
  typography: {
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    button: {
      fontWeight: 700,
      letterSpacing: "0.02em",
      textTransform: "none",
    },
  },
  palette: {
    primary: {
      main: "#ff9800",
      dark: "#e07f00",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#2f2f2f",
    },
    validation: {
      success: {
        main: "#aed581",
      },
      warn: {
        main: "#fdd835",
      },
    },
    background: {
      default: "#f9f8f8",
      paper: "rgb(255, 255, 255)",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          minHeight: 44,
          borderRadius: 10,
          boxShadow: "none",
        },
        containedPrimary: {
          "&:hover": {
            backgroundColor: "#e07f00",
            boxShadow: "none",
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: "#ffffff",
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontWeight: 500,
        },
      },
    },
  },
});

// export const { makeStyles, useStyles } = createMakeStyles({ useTheme: () => theme });
export const { makeStyles, useStyles } = createMakeStyles<typeof theme>({
  useTheme,
});
export const { withStyles } = createWithStyles({ useTheme });

export const muiCache = createCache({
  key: "css",
  prepend: true,
});
export const tssCache = createCache({
  key: "tss",
  prepend: false,
});

export function Theme(props: React.PropsWithChildren<{}>) {
  return (
    <CacheProvider value={muiCache}>
      <TssCacheProvider value={tssCache}>
        <ThemeProvider theme={theme} children={props.children} />
      </TssCacheProvider>
    </CacheProvider>
  );
}
